import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FatalError = () => /*#__PURE__*/_jsxs(UIErrorMessage, {
  type: "badRequest",
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "conversations-error-reporting.fatalError.refreshThePage"
    })
  }), /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "conversations-error-reporting.fatalError.contactSupport"
    })
  })]
});
FatalError.displayName = 'FatalError';
export default FatalError;